<template>
  <div id="app">
    <app-loading v-if="loadingVisible" />
    <router-view :class="{blured:loadingVisible}" />
    <noty-container />
  </div>
</template>

<script>
import appLoading from "./components/app-loading";
import notyContainer from "./components/noty-container";
import { mapGetters} from "vuex";

export default {
    components: {
    "app-loading": appLoading,
    "noty-container": notyContainer
  },
  computed: {
    ...mapGetters({
        loadingVisible: "pendingRequestsCount"
      })    
  },
  beforeMount(){
    this.$store.dispatch('initClock');
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;  
  touch-action: none;
  width: 100%;
  display: flex;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: 0;
}
</style>
